import {PortfolioType} from '../portfolio-type.model';
import {SelectedInvestments} from '../selected-investments.model';
import {PreferredCategories} from '../portfolio-preferences.model';
import {PortfolioCreationData} from './portfolio-creation-data.model';

export class ManualInvestPortfolioCreationData implements PortfolioCreationData {
    portfolioName: string;
    portfolioType: PortfolioType;
    readonly portfolioAmount: number;
    readonly tempPortfolioId: string;
    public selectedInvestments: SelectedInvestments;
    portfolioPreference: PreferredCategories[];

    constructor(tempPortfolioId: string, portfolioAmount: number);
    constructor(tempPortfolioId: string, portfolioAmount: number, portfolioName: string, portfolioType: PortfolioType,
                selectedInvestments: SelectedInvestments, portfolioPreference: PreferredCategories[])
    constructor(tempPortfolioId: string, portfolioAmount: number, portfolioName?: string, portfolioType?: PortfolioType,
                selectedInvestments?: SelectedInvestments, portfolioPreference?: PreferredCategories[]) {
        this.portfolioName = portfolioName;
        this.portfolioType = portfolioType;
        this.portfolioAmount = portfolioAmount;
        this.tempPortfolioId = tempPortfolioId;
        this.selectedInvestments = selectedInvestments;
        this.portfolioPreference = portfolioPreference;
    }

    public static from(creationData: any | null): ManualInvestPortfolioCreationData {
        if (!creationData) {
            return null;
        }
        return new ManualInvestPortfolioCreationData(creationData.tempPortfolioId, creationData.portfolioAmount, creationData.portfolioName,
            creationData.portfolioType, SelectedInvestments.from(creationData.selectedInvestments), creationData.portfolioPreference);
    }
}